import React, { useEffect, useState, useContext } from 'react';
import { withRouter} from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import axiosConfig from '../../../../utils/axiosConfig';
import Alert from '@material-ui/lab/Alert';
import { Formik, Form, Field } from 'formik';
import { fieldToTextField, TextField, TextFieldProps, Select, Switch } from 'formik-material-ui';
import {
    Box, Button, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    FormHelperText, Grid, List, ListItem, ListItemText,
    MenuItem, Slide, Typography
} from '@material-ui/core';
import SnackbarPopup from '../../../../components/Shared/SnackbarPopup/SnackbarPopup';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import { StateContext, DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ModalForm = (props) => {
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState, globalState, facultyState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    const [errorMessages, setErrorMessages] = useState([]);
    const [classroomsDropdown, setClassroomsDropdown] = useState([]);
    const [file, setFile] = useState('');
    const [fileUploadLabel, setFileUploadLabel] = useState(
        <><LibraryBooksIcon /><p style={{marginLeft: '5px', fontWeight: '500'}}>Choose a file to upload (required)</p></>
    );

    const [ebook, setEbook] = useState({
        classroom_id: 0,
        title: ""
    });

    async function uploadEbook(values, resetForm) {

        const formData = new FormData();
        formData.append('file', file);
        formData.append('classroom_id', values.classroom_id);
        formData.append('title', values.title);

        try {

            const res = await axiosConfig.post(`/e-books`, formData);

            if (res.data.status_code == 'ok') {
                setFile('');
                setFileUploadLabel(<><LibraryBooksIcon /> <p style={{marginLeft: '5px', fontWeight: '500'}}>Choose a file to upload (required)</p></>);
                globalDispatch({type: 'setSnackbarMsg', value: 'E-book uploaded successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});

                props.fetchEbooks();
                props.handleClose();
            }

        } catch (err) {

            if (err.response.status === 422) {
                const errors = err.response.data.errors;

                let errorMsgs = [];
                Object.keys(errors).map((error, index) => {
                    if (errors[error].length > 0) {
                        errors[error].map((err1, index1) => {
                            errorMsgs.push(err1);
                        });
                    } else {
                        errorMsgs.push(errors[error][0]);
                    }
                });

                setErrorMessages(errorMsgs);
            }
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    const fetchClassrooms = () => {
        axiosConfig.get('/classrooms')
            .then(response => {
                const { data } = response.data;
                const classroomsArr = [];
                data.map(function (data, index) {
                    classroomsArr.push({
                        id: data.id,
                        name: data.name,
                        section: data.section
                    });
                });

                setClassroomsDropdown(classroomsArr);
            })
            .catch(err => {
                console.log(err);
            });
    }

    const handleFileChange = (event) => {
        try {
            console.log(event.target.files[0].name);
            setFileUploadLabel(event.target.files[0].name);
            setFile(event.target.files[0]);
        } catch (e) {
            return;
        }
    }

    useEffect(() => {

        if (props.open) {
            setFile('');
            setFileUploadLabel(<><LibraryBooksIcon /> <p style={{marginLeft: '5px', fontWeight: '500'}}>Choose a file to upload (required)</p></>);
            setErrorMessages('');
            fetchClassrooms();
        }

    }, [props.open]);

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={'sm'}
            TransitionComponent={Transition}
            disableBackdropClick
        >
            <Formik
                initialValues={ebook}
                validate={(values) => {
                    const errors = {};

                    if (!values.classroom_id) {
                        errors.classroom_id = 'This field is required';
                    }

                    if (!values.title) {
                        errors.title = 'This field is required';
                    }

                    return errors;
                }}
                onSubmit={(values, {setSubmitting, resetForm}) => {
                    setSubmitting(false);
                    globalDispatch({type: 'setIsLoading', value: true});
                    uploadEbook(values, resetForm);
                }}
            >
                {({submitForm, isSubmitting, touched, errors}) => (
                    <Form>
                        <DialogTitle id="form-dialog-title">
                            {props.dialogTitle}
                        </DialogTitle>
                        <DialogContent>

                            <Grid container alignItems="flex-start" spacing={2}>

                                {errorMessages.length > 0 && (
                                    <Grid item xs={12}>
                                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                                            {errorMessages.map((key, i) => (
                                                <Typography key={i}>
                                                    {key}
                                                </Typography>
                                            ))}
                                        </Alert>
                                    </Grid>
                                )}

                                <Grid item xs={12}>
                                    <Field
                                        error={errors.classroom_id && true}
                                        component={Select}
                                        name="classroom_id"
                                        multiple={false}
                                        inputProps={{name: 'classroom_id', id: 'classroom_id'}}
                                        fullWidth
                                        variant="outlined"
                                        displayEmpty
                                    >
                                        <MenuItem value="0">-Select Class-</MenuItem>

                                        {classroomsDropdown.map((classroom, i) => (
                                            <MenuItem key={classroom.id} value={classroom.id}>
                                                {classroom.name} ({classroom.section})
                                            </MenuItem>
                                        ))}
                                    </Field>

                                    {errors.classroom_id && (
                                        <Box px={1.5}>
                                            <FormHelperText error={true}>
                                                {errors.classroom_id}
                                            </FormHelperText>
                                        </Box>
                                    )}
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Book Title*"
                                        name="title"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Box py={1}>
                                        <Button
                                            variant="outlined"
                                            size="medium"
                                            component="label"
                                            fullWidth
                                            type="button"
                                            style={{justifyContent: "flex-start"}}
                                        >
                                            {fileUploadLabel}
                                            <input type="file" onChange={handleFileChange} hidden />
                                        </Button>
                                    </Box>
                                </Grid>

                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={props.handleClose}
                                disabled={isSubmitting}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={isSubmitting}
                                onClick={submitForm} color="primary"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );

}

export default ModalForm;